import { createReduxServiceModule } from "@onhandtech/onhand-fe-shared/lib/redux";
import {
	createRequestError,
	type RequestArgs,
} from "@onhandtech/onhand-fe-shared/lib/request";
import type { AxiosError } from "axios";

import { moduleName } from "./delete-campaign.types";

const args: RequestArgs<boolean, boolean> = {
	handleFailure: (error: AxiosError) => createRequestError(error, moduleName),
	handleSuccess: () => true,
	method: "DELETE",
	url: "", // Override with campaign ID
};

const getCampaignModule = () =>
	createReduxServiceModule<boolean, boolean>({
		args,
		moduleName,
	});

export default getCampaignModule;
